const status = {
	journal: {
		standardMaterial: '표준물질',
		taskStrandardMaterial: '작업표준물질',
		taskStrandardMaterial2:'작업표준물질',
		innerStandardMaterial: '내부작업표준물질',
		testingSubstance: '작업 물질 검정',
		analysisResult2: '시료분석결과2',
		analysisResult2_sample: '시료분석결과2',
		analysisResult3: '수질측정항목',
		analysisResult4_sample: '시료농도별 유영저해 개체수',
		controlGroup: '시험환경조건',
		iqcChart: '내부정도관리차트',
		plantingLiquid: '식종액',
		analysisResult: '시험분석결과',
		ccv: 'CCV',
		icv:'ICV',
		useReagent: '사용시약'
	},
	fun: {
		delete: '삭제',
		edit: '수정',
		add: '생성',
		change: '변경',
		input: '입력'
	},
	text: {
		WORK_ACCEPTED: '접수완료',
		WORK_REQUEST: '분석요청',
		WORK_ANALYSIS: '시험분석',
		WORK_ANALYSIS_COMPLETE: '분석완료',
		WORK_DIRECTOR_REVIEW: '기술책임자 검토',
		WORK_IMPLEMENTATION_REVIEW: '성적서 결재',
		WORK_APPROVAL: '승인',
		WORK_COMPLETE: '완료',
		WORK_CANCEL: '계약 취소',
		ISSUE_ACCEPTED: '이슈 업',
		ISSUE_COMPLETE: '처리완료',
		CALCULATE_NOT_COMPLETE: '미완료',
		CALCULATE_COMPLETE: '완료',
		ANALYSIS_ING: '진행중',
		ANALYSIS_COMPLETE: '완료',
		DIRECTOR_WAIT: '대기',
		DIRECTOR_APPROVAL: '승인',
		DIRECTOR_REJECT: '반려',
		SETTLE_PAID: '입금',
		WAIT: '진행중',
		COMPLETE: '분석완료',
		SETTLE_TAX: '세금계산서 발급',
		SETTLE_DISCOUNT: '감액',
		SETTLE_INCREASE: '증액'
	},
	color: {
		WORK_ACCEPTED: 'orange',
		WORK_REQUEST: 'yellow',
		WORK_ANALYSIS: 'aquamarine',
		WORK_ANALYSIS_COMPLETE: 'green',
		WORK_DIRECTOR_REVIEW: 'violet',
		WORK_IMPLEMENTATION_REVIEW: 'purple',
		WORK_APPROVAL: 'skyblue',
		WORK_COMPLETE: 'lightgreen',
		WORK_CANCEL: 'red',
		ISSUE_ACCEPTED: 'lightred',
		ISSUE_COMPLETE: 'brightgreen',
		CALCULATE_NOT_COMPLETE: 'red',
		CALCULATE_COMPLETE: 'lightgreen',
		ANALYSIS_ING: 'orange',
		ANALYSIS_COMPLETE: 'violet',
		DIRECTOR_WAIT: '',
		DIRECTOR_APPROVAL: '',
		DIRECTOR_REJECT: '',
		WAIT: 'orange',
		COMPLETE: 'violet'
	},
	issue: [
		{
			text: '이슈 업',
			value: 'ISSUE_ACCEPTED',
			color: 'lightred',
			textColor: 'red'
		},
		{
			text: '처리완료',
			value: 'ISSUE_COMPLETE',
			color: 'brightgreen',
			textColor: 'green'
		}
	],
	project: [
		{
			text: '접수완료',
			value: 'WORK_ACCEPTED',
			color: 'orange',
			backgroundColor: '#FF922D',
			order: 1
		},
		{
			text: '분석요청',
			value: 'WORK_REQUEST',
			color: 'yellow',
			backgroundColor: '#FEC741',
			order: 2
		},
		{
			text: '시험분석',
			value: 'WORK_ANALYSIS',
			color: 'pcolor',
			backgroundColor: '#59C1B3',
			order: 3
		},
		{
			text: '분석완료',
			value: 'WORK_ANALYSIS_COMPLETE',
			color: 'green',
			backgroundColor: '#00884F',
			order: 4
		},
		{
			text: '기술책임자 검토',
			value: 'WORK_DIRECTOR_REVIEW',
			color: 'violet',
			backgroundColor: '#6C60CD',
			order: 5
		},
		{
			text: '성적서 결재',
			value: 'WORK_IMPLEMENTATION_REVIEW',
			color: 'purple',
			backgroundColor: '#BE4467',
			order: 6
		},
		{
			text: '승인',
			value: 'WORK_APPROVAL',
			color: 'skyblue',
			backgroundColor: '#66BCEA',
			order: 7
		},
		{
			text: '완료',
			value: 'WORK_COMPLETE',
			color: 'lightgreen',
			backgroundColor: '#6EBF60',
			order: 8
		}
	],
	project_issue: {
		approval: {
			value: 'APPROVAL',
			text: '승인'
		},
		collect: {
			value: 'COLLECT',
			text: '회수'
		},
		returned: {
			value: 'RETURN',
			text: '반려'
		},
		request: {
			value: 'REQUEST',
			text: '요청'
		}
	},
	approval: [
		{
			text: '대기',
			value: 'WAIT',
			img: require('@/assets/img/needtoconclude.png')
		},
		{
			text: '반려',
			value: 'REJECT',
			img: require('@/assets/img/notacceptable.png')
		},
		{
			text: '승인',
			value: 'ACCEPT',
			img: require('@/assets/img/acceptable.png')
		}
	],
	settle: {
		SETTLE_PAID: '입금',
		SETTLE_TAX: '세금계산서 발급',
		SETTLE_DISCOUNT: '감액',
		SETTLE_INCREASE: '증액'
	},
	delivery: {
		WAY_MAIL: '우편',
		WAY_VISIT: '방문'
	},
	filter: {
		category: '업무 코드',
		client: '고객사',
		disposal: '배출 업체',
		department: '담당 부서',
		isSettle: '정산',
		researchDepartment: '시험 부서'
	},
	project_detail: {
		summary: {
			status: '상태',
			projectType: '업무 구분',
			projectUser: '담당자',
			projectDept: '담당 부서',
			clientName: '고객사',
			projectDueDate: '발급예정일'
		},
		detail: [
			{ name: '상태', key: 'status', type: 'status' },
			{ name: '업무 구분', key: 'projectType' },
			{ name: '시료 수령 방법', key: 'projectSampleDeliveryWay' },
			{ name: '시료 채취 장소', key: 'projectAddress' },
			{ name: '용도', key: 'projectUseFor' },
			{ name: '의뢰일', key: 'projectRequestDate', type: 'date' },
			{ name: '발급 예정일', key: 'projectDueDate', type: 'date' },
			{ name: '담당 부서', key: 'projectDept' },
			{ name: '담당자', key: 'projectUser' },
			{ name: '시험부서', key: 'projectAnalysisDept' },
			{ name: '특이사항', key: 'projectDescription', type: 'memo' }
		],
		soil_detail: [
			{ name: '상태', key: 'status', type: 'status' },
			{ name: '업무 구분', key: 'projectType' },
			{ name: '시료 수령 방법', key: 'projectSampleDeliveryWay' },
			{ name: '시료 채취 장소', key: 'projectAddress' },
			// { name: '되메움토발생지', key: 'projectBackfill' },
			{ name: '저장물질', key: 'projectStorageMaterial' },
			{ name: '용도', key: 'projectUseFor' },
			{ name: '의뢰일', key: 'projectRequestDate', type: 'date' },
			{ name: '발급 예정일', key: 'projectDueDate', type: 'date' },
			{ name: '담당 부서', key: 'projectDept' },
			{ name: '담당자', key: 'projectUser' },
			{ name: '시험부서', key: 'projectAnalysisDept' },
			{ name: '특이사항', key: 'projectDescription', type: 'memo' }
		],
		disposal_detail: [
			{ name: '상태', key: 'status', type: 'status' },
			{ name: '업무 구분', key: 'projectType' },
			{ name: '시료 수령 방법', key: 'projectSampleDeliveryWay' },
			{ name: '시료 채취 장소', key: 'projectAddress' },
			{ name: '용도', key: 'projectUseFor' },
			{ name: '의뢰일', key: 'projectRequestDate', type: 'date' },
			{ name: '발급 예정일', key: 'projectDueDate', type: 'date' },
			{ name: '담당 부서', key: 'projectDept' },
			{ name: '담당자', key: 'projectUser' },
			{ name: '시험부서', key: 'projectAnalysisDept' },
			{ name: '특이사항', key: 'projectDescription', type: 'memo' }
		],
		client: [
			{ name: '고객사 이름', key: 'clientName' },
			{ name: '고객사 ID', key: 'clientId' },
			{ name: '사업자등록번호', key: 'clientBizNum' },
			{ name: '대표자', key: 'clientCeoName' },
			{ name: '연락처', key: 'clientPhone' },
			{ name: '팩스번호', key: 'clientFax' },
			{ name: '소재지', key: 'clientAddress' },
			{ name: '메모', key: 'clientMemo' }
			// { name: '회계 담당자 이름', key: 'clientAccountManagerName' },
			// { name: '회계 담당자 연락처', key: 'clientAccountManagerPhone' },
			// { name: '회계 담당자 이메일', key: 'clientAccountManagerEmail' },
		],
		disposal: [
			{ name: '배출 업체 이름', key: 'disposalName' },
			{ name: '배출 업체 ID', key: 'disposalCode' },
			{ name: '사업자등록번호', key: 'disposalBizNum' },
			{ name: '대표자', key: 'disposalCeoName' },
			{ name: '연락처', key: 'disposalPhone' },
			{ name: '팩스번호', key: 'disposalFax' },
			{ name: '소재지', key: 'disposalAddress' },
			{ name: '상위고객', key: 'parentClientName' },
			{ name: '메모', key: 'disposalMemo' }
		],
		sample: [
			{ name: '시료명(성적서 표기)', key: 'sampleName' },
			{ name: '시료 수령 방법', key: 'sampleDeliveryWay' },
			{ name: '시료 수', key: 'sampleCount' },
			{ name: '시료 채취자', key: 'sampleCollector' },
			{
				name: '시료 채취 시작일',
				key: 'sampleCollectDate',
				type: 'date'
			},
			{
				name: '시료 채취 종료일',
				key: 'sampleCollectEndDate',
				type: 'date'
			},
			{ name: '시험 방법', key: 'sampleTestMethod' },
			// { name: '추가 시험 방법', key: 'sampleTestSecondMethod' },
			{ name: '시료상의 문제', key: 'sampleDescription' },
			// 시험의뢰서 ④시험항목과 같은 값(project_sample.sample_test_description).
			// 종전에는 의뢰서에만 찍힐 뿐 화면에서는 볼 수 없었다 (2026-08-20 현업 3-3).
			// 길어서(최대 778자) type:'memo' 로 한 줄 전체를 쓴다.
			{ name: '시험항목', key: 'sampleTestDescription', type: 'memo' }
		],
		settle: {
			paidAmount: '계약금액 / 입금액 (VAT포함)',
			unpaidAmount: '잔금',
			// "paidDate": "입금 예정일",
			latestTaxDate: '최종 계산서 발행일'
		},
		settle_list: [
			{
				name: '계약금액 / 입금액 (VAT포함)',
				key: 'amount',
				type: 'price'
			},
			// { name: '입금 예정일', key: 'paidDate', type: 'date' },
			{ name: '잔금', key: 'unpaidAmount' },
			{ name: '최종 계산서 발행일', key: 'latestTaxDate', type: 'date' },
			{ name: '', key: 'sample' },
			{ name: '회계 담당자', key: 'accountManager.name' },
			{ name: '회계 담당자 팩스번호', key: 'accountManager.fax' },
			{ name: '회계 담당자 연락처', key: 'accountManager.phone' },
			{ name: '회계 담당자 이메일', key: 'accountManager.email' }
		]
	}
}

export default status
